var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIconCheckReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/refresh-left-square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refresh-left-square"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.4775 7.50977C10.9775 7.35977 11.5275 7.25977 12.1475 7.25977C14.9075 7.25977 17.1475 9.49977 17.1475 12.2598C17.1475 15.0198 14.9075 17.2598 12.1475 17.2598C9.38746 17.2598 7.14746 15.0198 7.14746 12.2598C7.14746 11.2298 7.45746 10.2798 7.98746 9.47977",
    stroke: "#FDB913",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.76758 7.65024L11.4276 5.74023",
    stroke: "#FDB913",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.76758 7.65039L11.7076 9.07039",
    stroke: "#FDB913",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M9.14746 22H15.1475C20.1475 22 22.1475 20 22.1475 15V9C22.1475 4 20.1475 2 15.1475 2H9.14746C4.14746 2 2.14746 4 2.14746 9V15C2.14746 20 4.14746 22 9.14746 22Z",
    stroke: "#2065B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIconCheckReload);
export default __webpack_public_path__ + "static/media/profile-icon-check-reload.bbd62cb5df60cef201390aee8268ad69.svg";
export { ForwardRef as ReactComponent };